module.exports = __webpack_public_path__ + "save-button.svg?578b38a74dce13ee6942eee790b0f2f4";


//////////////////
// WEBPACK FOOTER
// ./src/images/save-button.svg
// module id = 382
// module chunks = 0